import { isValidObject, objectToQueryString } from '../helpers/functions';

export const storeFront = {
  forVendor: {
    de: () => '/gastronomien',
    en: () => '/for-vendor',
  },
  forHotels: {
    de: () => '/hotels',
    en: () => '/hotels',
  },
  forCompany: {
    de: () => '/unternehmen',
    en: () => '/unternehmen',
  },
  // partnerGastronomien: {
  //   de: () => '/partner-gastronomien',
  //   en: () => '/partner-gastronomien',
  // },
  register: {
    de: () => '/registrieren',
    en: () => '/register',
  },
  otp: {
    de: () => '/otp',
    en: () => '/otp',
  },
  login: {
    en: () => '/login',
  },
  checkout: {
    de: () => '/kasse',
    en: () => '/kasse',
  },
  failedOrder: {
    de: () => '/kasse/callback/failed',
    en: () => '/kasse/callback/failed',
  },
  reorder: {
    de: () => '/kasse/callback/reorder',
    en: () => '/kasse/callback/reorder',
  },
  restaurants: {
    de: () => '/shops',
    en: () => '/shops',
  },
  onlineShops: {
    de: () => '/online-shop',
    en: () => '/online-shop',
  },
  city: {
    de: () => '/city',
    en: () => '/city',
  },
  cityShops: {
    de: (slug: string) => `/city/${slug}`,
    en: (slug: string) => `/city/${slug}`,
  },
  events: {
    de: () => 'veranstaltungen',
    en: () => 'veranstaltungen',
  },
  registerBusiness: {
    de: (params = {}) => {
      const pathname = '/restaurant-registrieren';
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
    en: (params = {}) => {
      const pathname = '/restaurant-registrieren';
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
  },
  loginBusiness: {
    de: () => '/unternehmen/login',
  },
  forgotPassword: {
    de: () => '/passwort-vergessen',
  },
  restaurantForgotPassword: {
    de: () => '/unternehmen/passwort-vergessen',
  },
  orderConfirm: {
    de: () => '/order-confirm',
  },
};

export const restaurant = {
  login: {
    de: () => '/unternehmen/login',
  },
  dashboard: {
    de: () => '/business/dash',
  },
  subscriptions: {
    de: (params = {}) => {
      const pathname = `/business/dash/subscriptions`;
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
    en: (params = {}) => {
      const pathname = `/business/dash/subscriptions`;
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
  },
  welcome: {
    en: () => '/restaurant-welcome',
  },
};
